// 共享类型 —— ICE 详情面板（与 EventBus race:status / race:host_status 对齐）

export interface QualityData {
  packetsReceived: number;
  packetsLost: number;
  throughputKbps: number;
  packetsSent?: number;          // host 侧发送方已发包数；client 侧无
  score?: number;
  rtt?: number;
  rttJitterMs?: number;          // client 侧 heavy 模式指标
  stableThroughputKbps?: number; // client 侧 heavy 模式指标（min/mean 百分比）
}

export interface RacingSessionStatus {
  raceId: string;
  label: string;
  status: string;
  iceState?: string;
  connectionType?: string;
  turnServer?: string;       // 该 session 实际选中的 TURN 主机名（浏览器侧来自 stats，host 侧来自上报）
  actualTurnEntry?: string;  // host 侧本 session 实际选中的内网入口"ip:port"（内网模式 relay）
  connectTime?: number;
  isWinner?: boolean;
  remoteCandidateCount?: number;
  quality?: QualityData;
}

export interface QualityThresholds {
  minThroughputKbps: number;
  maxLossPct: number;
  maxJitterMs: number;
}

export type WinReason = 'fast-win' | 'quality-select' | 'timeout-fallback' | 'forceRelay';

export interface RacingStatus {
  elapsedMs: number;
  phase?: 'connecting' | 'testing' | 'completed';
  sessions: RacingSessionStatus[];
  winner?: string;
  winReason?: WinReason;
  thresholds?: QualityThresholds;
}

// 信令链路状态
export type WsState = 'open' | 'connecting' | 'closed';
export type HostLinkState = 'online' | 'offline' | 'waiting';

export interface LinkState {
  ws: WsState;
  wsCloseCode?: number;
  host: HostLinkState;
  msgSent: number;
  msgRecv: number;
  lastMsgType: string;
  lastMsgAt: number;          // 时间戳；0 表示尚无消息
  // 信令服务器 HTTP 探测：null=未探测/ws在线；true=进程在响应；false=网络/超时
  // 用于 UI 区分"服务器挂"和"仅 WS 断"
  serverReachable?: boolean | null;
}

// 质量门槛默认值（与 IceRacingService QUALIFY_* 一致；回看/未收到 thresholds 时兜底）
export const DEFAULT_THRESHOLDS: QualityThresholds = {
  minThroughputKbps: 1700,
  maxLossPct: 5,
  maxJitterMs: 50,
};

// 回看快照：winner 时刻的 client + host 双侧状态
export interface RaceReviewSnapshot {
  client: RacingStatus;
  host: RacingStatus | null;
}
